<ng-container *ngIf="pagination > 1">
  <ul
    class="flex flex-wrap items-center justify-center my-2xl"
    data-test="pagination"
  >
    <li *ngIf="!isFirstPage" class="mr-2">
      <a
        app-vtmn-play-icon-button
        [href]="prevPageUrl"
        [size]="vtmnPlayButtonSize.SMALL"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
      >
        <vtmn-play-icon
          [ariaLabel]="'header.login.button.text' | translate"
          [name]="vtmnPlayIconTypeEnum.ChevronBackward"
          [height]="18"
          [width]="18"
        ></vtmn-play-icon>
      </a>
    </li>
    <ng-container *ngFor="let page of pageArray(pagination); index as i">
      <li
        *ngIf="i + 1 >= currentPage - 3 && i + 1 <= currentPage + 3"
        class="mr-2"
      >
        <a
          app-vtmn-play-button
          [href]="paginationUrlGenerator(i)"
          [size]="vtmnPlayButtonSize.SMALL"
          [variant]="linkVariant(i + 1)"
          [shape]="vtmnPlayButtonShape.SQUARED"
        >
          {{ i + 1 }}
        </a>
      </li>
    </ng-container>

    <li *ngIf="!isLastPage" class="ml-2">
      <a
        app-vtmn-play-icon-button
        [href]="nextPageUrl"
        [size]="vtmnPlayButtonSize.SMALL"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
      >
        <vtmn-play-icon
          [ariaLabel]="'header.login.button.text' | translate"
          [name]="vtmnPlayIconTypeEnum.ChevronForward"
          [height]="18"
          [width]="18"
        ></vtmn-play-icon>
      </a>
    </li>
  </ul>
</ng-container>
